// extracted by mini-css-extract-plugin
export default {"psevdoBody":"HomePage_psevdoBody__Oa0Dx"};